const ITEMS = [
  "Rapid-Response Repairs",
  "Drywall & Hardware",
  "Drip Fixes & Caulking",
  "Carpentry & Deck Repair",
  "Rental Turnover Readiness",
  "Pressure Washing",
  "Clear Written Scopes",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-stone-200 bg-white py-5"
      aria-hidden
    >
      <div className="animate-marquee flex w-max items-center gap-10">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display whitespace-nowrap text-sm font-semibold uppercase tracking-[0.18em] text-slate-400">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-amber-500/70" />
          </span>
        ))}
      </div>
    </div>
  );
}
